"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const app_1 = __importDefault(require("firebase/app"));
const PageViewMonitor = ({ children, }) => {
    const history = react_router_dom_1.useHistory();
    react_1.useEffect(() => {
        const analytics = app_1.default.analytics();
        // FIXME: this is a temporary solution for publishing the event again with correct user property
        // automatic page view publication cannot be disable for now due to some bugs for firebase sdk
        // issue: https://github.com/firebase/firebase-js-sdk/issues/3988
        // Tried the workaround in the issue but doesn't work
        analytics.logEvent('page_view', {});
    });
    react_1.useEffect(() => {
        const dispose = history.listen(() => {
            const analytics = app_1.default.analytics();
            analytics.logEvent('page_view', {});
        });
        return () => {
            dispose();
        };
    });
    return children;
};
exports.default = PageViewMonitor;
